<template>
  <section class="question-subject-container">
    <div class="q-cover" v-if="qdata.page_type === 1">
      <img v-if="qdata.front_img" :src="qdata.front_img" alt="封面图" />
    </div>
    <div v-if="qdata.page_type === 1">
      <h3 class="q-title">{{ qdata.title }}</h3>
      <p class="q-desc">{{ qdata.explain }}</p>
      <SiglePage :qlist="qlist" :qdata="qdata"></SiglePage>
    </div>
    <div v-if="qdata.page_type === 2">
      <MultiPage :qlist="qlist" :qdata="qdata" mode="multi"></MultiPage>
    </div>
  </section>
</template>

<script>
// 产品prd地址：跳转、显示逻辑比较复杂
// https://wiki.huolala.work/pages/viewpage.action?pageId=76266851
// 后端接口文档
// https://huolala.feishu.cn/docs/doccnDTbH12Ft6YnF7NYoz36u7c#
// 跳转类型 1-跳转题目 2-正常结束 3-提前结束
import { webcall, getAllUrlParams } from '@hll/driver-js-utils';
import SiglePage from './single-page.vue';
import MultiPage from './multi-page.vue';

export default {
  name: 'QuestionSubject',
  components: { SiglePage, MultiPage },
  data() {
    return {
      qdata: {}, // 问卷详情
      qlist: [], // 题目列表
    };
  },
  computed: {},
  created() {
    try {
      const questionnaire = sessionStorage.getItem('questionnaire') || {};
      this.qdata = JSON.parse(questionnaire);
      this.qlist = this.qdata?.subject_config?.subjects;
    } catch {
      // 此方法做兜底展示，正常情况下都是从guide页面走进来，从sessionStorage里面获取问卷详情
      // 如果用户直接访问主页链接跳回引导页
      console.log('跳回首页');
      const urlParams = getAllUrlParams(window.location.href);
      this.$router.replace({
        name: 'question/guide',
        query: { ...urlParams },
      });
    }
  },
  mounted() {
    webcall({ action: 'setTitle', title: '问卷调查' });
  },
};
</script>

<style lang="less" scoped>
.question-subject-container {
  padding: 0 16px;
  .q-cover {
    font-size: 0;
    margin-top: 18px;
    margin-bottom: 10px;
    img {
      width: 100%;
      border-radius: 5px;
    }
  }
  .q-title {
    font-size: 20px;
    color: #000;
    font-weight: 500;
  }
  .q-desc {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.64);
    margin: 8px 0 26px;
  }
}
</style>
